import { ProductListingResponseV3 } from "../types/api/ProductListingResponseV3"

export const transformDepictProductData = (data: {
    data: { displays: ProductListingResponseV3["displays"] }
}) => {
    const displayResults = data.data.displays.map((display: any) => {
        display.variant_displays = [
            ...display.variant_displays.map((variant: any) => {
                variant.image_urls =
                    variant.image_urls.length > 2
                        ? variant.image_urls.slice(0, 2)
                        : variant.image_urls
                return Object.fromEntries(
                    Object.entries(variant).filter(([_, v]) => v !== null)
                )
            })
        ]
        return Object.fromEntries(Object.entries(display).filter(([_, v]) => v !== null))
    })

    // Return modified data structure with processed displays
    return {
        ...data.data,
        displays: displayResults
    }
}
